import React, { useEffect, useState } from "react";
import TableHeading from "../../Components/common/table/Tableheading";
import { IoClose } from "react-icons/io5";
import { showData } from "../../Utils/APIs/commonShowAPI";
import axios from "axios";
import { getCookie } from "../../Utils/cookies";
import Filter from "../../Components/filter/Index";
import { FaFilter } from "react-icons/fa";

const Index = () => {
  const [insuranceList, setInsuranceList] = useState([]);
  const heading = [
    "Sr. No",
    "Panel_Broken / Stolen_Date",
    "Saral ID",
    "Farmer Name",
    "Farmer Mobile",
    "Farmer Address",
    "Company Name",
    "Complaint Details",
    "Product",
    "status",
  ];

  const [searchBtnClicked, setSearchBtnClicked] = useState(false);

  // filter field
  const [trackingId, setTrackingId] = useState("");
  const [saralId, setSaralId] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const empData = JSON.parse(getCookie("empData"));
  console.log("empData in insurance list", empData);
  //   const LIMIT = 50;
  const [page, setPage] = useState(1);

  const filters = `page=${page}&saralId=${saralId}&contact=${contactNo}&trackingId=${trackingId}&startDate=${startDate}&endDate=${endDate}`;

  // for filter
  const [filterVisible, setFilterVisible] = useState(false);
  const filterToggle = () => {
    setFilterVisible(!filterVisible);
  };

  useEffect(() => {
    const fetchData = async () => {
      await showData(`farmer/insuranceComplaint?${filters}`, setInsuranceList);
    };
    fetchData();
  }, [page, searchBtnClicked]);

  const [isOpen, setIsOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openInsuranceDetails = (data) => {
    console.log("selected data", data);
    setSelectedData(data);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setSelectedData([]);
  };

  const [brokenPanelImage, setBrokenPanelImage] = useState(null);
  const [punchnama, setPunchnama] = useState(null);
  const [newPaper, setNewPaper] = useState(null);
  const [jcr, setJcr] = useState(null);
  const [invoice, setInvoice] = useState(null);
  const [firCopy, setFirCopy] = useState(null);
  const [firFinalCopy, setFirFinalCopy] = useState(null);
  const [lossDate, setLossDate] = useState(null);
  const [stolenProduct, setStolenProduct] = useState(null);
  const [estimatedAmount, setEstimatedAmount] = useState(null);

  const insuranceUpdate = async () => {
    const formData = new FormData();
    brokenPanelImage !== null &&
      formData.append("brokenPanelImage", brokenPanelImage);
    punchnama !== null && formData.append("punchnama", punchnama);
    newPaper !== null && formData.append("newsPaperCutting", newPaper);
    jcr !== null && formData.append("jcr", jcr);
    invoice !== null && formData.append("invoice", invoice);
    lossDate !== null && formData.append("brokenOrStolenDate", lossDate);
    stolenProduct !== null && formData.append("stolenProduct", stolenProduct);
    estimatedAmount !== null &&
      formData.append("estimatedAmount", estimatedAmount);
    firCopy !== null && formData.append("firCopy", firCopy);
    firFinalCopy !== null && formData.append("firFinalCopy", firFinalCopy);

    formData.append("id", selectedData?._id);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/insurance/updateComplaint`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200 || response.data.success) {
        alert("Insurance Complaint Updated Successfully");
        const updatedList = insuranceList.map((item) =>
          item._id === selectedData._id
            ? { ...item, ...response.data.data }
            : item
        );
        setInsuranceList(updatedList);
        setIsOpen(false);
      }
    } catch (error) {
      console.error("Error updating insurance complaint:", error);
      alert("Failed to update insurance complaint. Please try again.");
    }
  };

  const insuranceMail = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/insurance/sendMail`,
        {
          id: selectedData?._id,
        }
      );

      if (response.status === 200 || response.data.success) {
        alert(response.data.message || "Insurance mail sent successfully");
      }
    } catch (error) {
      console.error("Error sending insurance mail:", error);
      alert(
        error?.response?.data?.message ||
          "Failed to send insurance mail. Please try again."
      );
    }
  };
  const intimationDone = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/insurance/intimationDone`,
        {
          id: selectedData?._id,
        }
      );

      if (response.status === 200 || response.data.success) {
        alert(response.data.message || "Update successfully");
      }
    } catch (error) {
      console.error("Error to update insurance complaint:", error);
      alert(
        error?.response?.data?.message ||
          "Failed to update insurance. Please try again."
      );
    }
  };
  const dispatchDone = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/insurance/dispatchDone`,
        {
          id: selectedData?._id,
        }
      );

      if (response.status === 200 || response.data.success) {
        alert(response.data.message || "Update successfully");
      }
    } catch (error) {
      console.error("Error to update insurance complaint:", error);
      alert(
        error?.response?.data?.message ||
          "Failed to update insurance. Please try again."
      );
    }
  };
  return (
    <div className="h-full flex flex-col overflow-auto">
      <div>
        <h1 className="text-3xl font-semibold tracking-widest text-center p-2 bg-gray-50 rounded-lg">
          I<span className="text-lg">NSURANCE</span> S
          <span className="text-lg">ECTION</span>
        </h1>
      </div>

      <div className="relative *:overflow-x-auto shadow-md sm:rounded-lg m-4">
        <table className="relative w-full text-sm text-gray-500 text-center">
          <TableHeading list={heading} />
          <tbody className="bg-white divide-y divide-gray-200">
            {insuranceList && insuranceList.length > 0 ? (
              insuranceList.map((item, index) => (
                <tr
                  key={item?._id}
                  className="hover:bg-gray-100"
                  onClick={() => openInsuranceDetails(item)}
                >
                  <td className="px-6 py-4 whitespace-nowrap">{index + 1}</td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {new Date(item?.brokenOrStolenDate).toLocaleDateString() ||
                      "Not Define"}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {item?.Farmer?.[0]?.saralId}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {item?.Farmer?.[0]?.farmerName}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {item?.Farmer?.[0]?.contact || item?.contact}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">{`${item?.Farmer?.[0]?.village}, ${item?.Farmer?.[0]?.block}, ${item?.Farmer?.[0]?.district}, ${item?.Farmer?.[0]?.state}`}</td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {item?.company}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {item?.complaintDetails}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {item?.Farmer?.[0]?.product}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {item?.status}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={heading.length} className="text-center p-4">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Filter Button */}
      <button
        className="fixed bottom-24 right-12 bg-yellow-400 p-3 rounded-lg font-medium shadow-lg"
        onClick={filterToggle}
      >
        <FaFilter />
      </button>

      {/* Filter Component */}
      {filterVisible && (
        <Filter
          toggleState={setFilterVisible}
          selectedStage={null}
          setSelectedStage={null}
          trackingId={trackingId}
          setTrackingId={setTrackingId}
          contactNo={contactNo}
          setContactNo={setContactNo}
          setSaralId={setSaralId}
          saralId={saralId}
          searchBtn={searchBtnClicked}
          setSearchBtn={setSearchBtnClicked}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
        />
      )}

      {/* Modal for Insurance Details */}
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 h-full">
          <div className="relative bg-white rounded-lg shadow-lg p-6 w-full max-w-7xl">
            <h2 className="text-xl font-bold mb-4 w-full p-2">
              Complaint Details
            </h2>
            <table className="w-full text-sm text-left text-gray-500">
              <tr className="bg-gray-50 border-b">
                <th className="px-2 py-1 text-black text-left">Saral Id</th>
                <td className="px-2 py-1 text-black">
                  {selectedData?.Farmer?.[0]?.saralId}
                </td>
                <th className="px-2 py-1 text-black text-left">Farmer Name</th>
                <td className="px-2 py-1 text-black">
                  {selectedData?.Farmer?.[0]?.farmerName}
                </td>
                <th className="px-2 py-1 text-black text-left">
                  Complaint Type
                </th>
                <td className="px-2 py-1 text-black">
                  {selectedData?.complaintDetails}
                </td>
              </tr>
              <tr className="bg-gray-50 border-b">
                <th className="px-2 py-1 text-black text-left">
                  Farmer Mobile
                </th>
                <td className="px-2 py-1 text-black">
                  {selectedData?.Farmer?.[0]?.contact || selectedData?.contact}
                </td>
                <th className="px-2 py-1 text-black">Product</th>
                <td className="px-2 py-1 text-black">
                  {selectedData?.Farmer?.[0]?.product}
                </td>
                <th className="px-2 py-1 text-black">Company</th>
                <td className="px-2 py-1 text-black">
                  {selectedData?.company}
                </td>
              </tr>
              <tr className="bg-gray-50 border-b">
                <th className="px-2 py-1 text-black">Stolen Product</th>
                <td className="px-2 py-1 text-black">
                  {selectedData?.stolenProduct}
                </td>
                <th className="px-2 py-1 text-black">Estimated Amount</th>
                <td className="px-2 py-1 text-black">
                  {selectedData?.estimatedAmount}
                </td>
                <th className="px-2 py-1 text-black">
                  Panel Broken / Stolen Date
                </th>
                <td className="px-2 py-1 text-black">
                  {new Date(
                    selectedData?.brokenOrStolenDate
                  ).toLocaleDateString() || "Not Define"}
                </td>
              </tr>
              <tr className="bg-gray-50 border-b">
                <th className="px-2 py-1 text-black">Status</th>
                <td className="px-2 py-1 text-black">{selectedData?.status}</td>
                <th className="px-2 py-1 text-black">JCR</th>
                <td className="px-2 py-1 text-black">
                  {selectedData?.jcr ? (
                    <a
                      href={`${process.env.REACT_APP_INSURANCE_URL}${selectedData?.jcr}`}
                      target="blank"
                      className="pl-3 text-blue-500 hover:underline"
                    >
                      View JCR
                    </a>
                  ) : (
                    "Not Provided"
                  )}
                </td>
                <th className="px-2 py-1 text-black">Invoice</th>
                <td className="px-2 py-1 text-black">
                  {selectedData?.jcr ? (
                    <a
                      href={`${process.env.REACT_APP_API_URL}${selectedData?.invoice}`}
                      target="blank"
                      className="pl-3 text-blue-500 hover:underline"
                    >
                      View Invoice
                    </a>
                  ) : (
                    "Not Provided"
                  )}
                </td>
              </tr>
            </table>
            <table className="w-full text-sm text-center text-gray-500 px-2">
              <tr className="bg-gray-100 border-b">
                <th className="px-2 py-1 text-black">Broken Panel</th>
                <th className="px-2 py-1 text-black">Punchnama</th>
                <th className="px-2 py-1 text-black">New Paper catting</th>
              </tr>
              <tr className="bg-gray-50 border-b h-32">
                <td className="text-black">
                  {selectedData?.brokenPanelImage ? (
                    <img
                      src={`${process.env.REACT_APP_API_URL}/${selectedData?.brokenPanelImage}`}
                      alt="Broken Panel"
                      className="w-full max-h-64 rounded"
                    />
                  ) : (
                    "Not Provided"
                  )}
                </td>
                <td className="text-black">
                  {selectedData?.punchnama ? (
                    <img
                      src={`${process.env.REACT_APP_API_URL}/${selectedData?.punchnama}`}
                      alt="Punchnama"
                      className="w-full max-h-64 rounded"
                    />
                  ) : (
                    "Not Provided"
                  )}
                </td>
                <td className="text-black">
                  {selectedData?.newsPaperCutting ? (
                    <img
                      src={`${process.env.REACT_APP_API_URL}/${selectedData?.newsPaperCutting}`}
                      alt="News Paper Cutting"
                      className="w-full max-h-64 rounded"
                    />
                  ) : (
                    "Not Provided"
                  )}
                </td>
              </tr>
            </table>
            <div className="flex justify-between items-center mb-4 flex-col w-full">
              <div className="flex justify-between items-center w-full mb-2 flex-col">
                <div className="w-full flex flex-col justify-evenly mt-2">
                  <div className="flex flex-row items-center gap-2 w-full">
                    <div>
                      <label
                        htmlFor="media"
                        className="block mb-2 text-sm font-medium text-gray-900"
                      >
                        Broken Panel Image
                      </label>
                      <input
                        type="file"
                        id="media"
                        accept="image/*"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
                        onChange={(e) => {
                          setBrokenPanelImage(e.target.files[0]);
                        }}
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="media"
                        className="block mb-2 text-sm font-medium text-gray-900"
                      >
                        Punchnama
                      </label>
                      <input
                        type="file"
                        id="media"
                        accept="image/*"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
                        onChange={(e) => {
                          setPunchnama(e.target.files[0]);
                        }}
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="media"
                        className="block mb-2 text-sm font-medium text-gray-900"
                      >
                        News Paper Cutting
                      </label>
                      <input
                        type="file"
                        id="media"
                        accept="image/*"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
                        onChange={(e) => {
                          setNewPaper(e.target.files[0]);
                        }}
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="media"
                        className="block mb-2 text-sm font-medium text-gray-900"
                      >
                        JCR(pdf)
                      </label>
                      <input
                        type="file"
                        id="media"
                        accept="application/pdf"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
                        onChange={(e) => {
                          setJcr(e.target.files[0]);
                        }}
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="media"
                        className="block mb-2 text-sm font-medium text-gray-900"
                      >
                        Invoice(pdf)
                      </label>
                      <input
                        type="file"
                        id="media"
                        accept="application/pdf"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
                        onChange={(e) => {
                          setInvoice(e.target.files[0]);
                        }}
                      />
                    </div>
                  </div>
                  <div className="flex flex-row items-center gap-5">
                    <div>
                      <label
                        htmlFor="media"
                        className="block mb-2 text-sm font-medium text-gray-900"
                      >
                        Fir Copy
                      </label>
                      <input
                        type="file"
                        id="media"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
                        onChange={(e) => {
                          setFirCopy(e.target.files[0]);
                        }}
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="media"
                        className="block mb-2 text-sm font-medium text-gray-900"
                      >
                        Fir Final Copy
                      </label>
                      <input
                        type="file"
                        id="media"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
                        onChange={(e) => {
                          setFirFinalCopy(e.target.files[0]);
                        }}
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="theftDate"
                        className="block mb-2 text-sm font-medium text-gray-900"
                      >
                        Date of Loss
                      </label>
                      <input
                        type="date"
                        id="theftDate"
                        value={lossDate || ""}
                        onChange={(e) => {
                          setLossDate(e.target.value);
                        }}
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block p-2.5"
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="theftDate"
                        className="block mb-2 text-sm font-medium text-gray-900"
                      >
                        stolen Product
                      </label>
                      <input
                        type="text"
                        id="theftDate"
                        value={stolenProduct || ""}
                        onChange={(e) => {
                          setStolenProduct(e.target.value);
                        }}
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block p-2.5"
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="theftDate"
                        className="block mb-2 text-sm font-medium text-gray-900"
                      >
                        Estimated Amount
                      </label>
                      <input
                        type="number"
                        id="theftDate"
                        value={estimatedAmount || ""}
                        onChange={(e) => {
                          setEstimatedAmount(e.target.value);
                        }}
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block p-2.5"
                      />
                    </div>
                    <button
                      className="bg-blue-600 px-2 py-2 mt-6 text-white rounded-sm"
                      onClick={() => insuranceUpdate()}
                    >
                      Update
                    </button>
                  </div>
                  <div className="flex flex-row items-center gap-5 mt-4">
                    {selectedData?.intimationDone === undefined ||
                    selectedData?.intimationDone === null ||
                    selectedData?.intimationDone === false ? (
                      <>
                        <button
                          className="bg-blue-600 px-2 py-2 mt-6 text-white rounded-sm"
                          onClick={() => insuranceMail()}
                        >
                          Insurance Mail
                        </button>
                        <button
                          className="bg-blue-600 px-2 py-2 mt-6 text-white rounded-sm"
                          onClick={() => intimationDone()}
                        >
                          Intimation Done
                        </button>{" "}
                      </>
                    ) : (
                      <span className="text-gray-500  mt-6">
                        Already Intimation.
                      </span>
                    )}
                    {((selectedData?.dispatched === undefined ||
                    selectedData?.dispatched === null ||
                    selectedData?.dispatched === false) && selectedData?.intimationDone === true) && 
                      <button
                        className="bg-blue-600 px-2 py-2 mt-6 text-white rounded-sm"
                        onClick={() => dispatchDone()}
                      >
                        Dispatch
                      </button>
                    }
                  </div>
                </div>
              </div>
            </div>
            <button
              className="absolute top-0 right-4 mt-4 px-1 py-1 bg-red-500 text-white rounded hover:bg-red-600"
              onClick={closeModal}
            >
              <IoClose />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Index;
